import { Empty } from "antd";
import KoboConverter from "Components/KoboConverter";
import Scaffold from "Components/Scaffold";
import { Separator } from "Components/Separator";
import { useGetLatestOrdersQuery } from "hooks/Dashboard/useGetLatestOrdersQuery";
import Moment from "react-moment";
import { Link } from "react-router-dom";

const NewOrders = () => {
  const { data } = useGetLatestOrdersQuery();

  const TopItemsList = () => {
    const isEmpty = data?.data.length === 0;

    if (isEmpty) {
      return (
        <div className="h-full grid place-content-center py-[40px]">
          <Empty />
        </div>
      );
    }

    return (
      <div className="">
        {data?.data.map(
          ({
            id,
            orderNo,
            customerName,
            totalProductsAmount,
            createdAt,
            customer,
            deliveryMethod,
            discountAmount,
          }: any) => (
            <div className="overflow-scroll">
              <div className="flex flex-row items-center gap-2 px-5 py-[15px] text-[12px]">
                <div className="w-3/12">
                  <Link to={`/order-management/${id}`} className="link">
                    {orderNo}
                  </Link>
                </div>
                <div className="w-3/12">
                  <Link
                    to={`/customer-management/${customer}`}
                    className=" text-orange underline"
                  >
                    {customerName}
                  </Link>
                </div>
                <div className="w-3/12">
                  <KoboConverter amount={totalProductsAmount} />
                </div>
                <div className="w-3/12">
                  <KoboConverter amount={discountAmount} />
                </div>
                <div className="w-3/12">{deliveryMethod}</div>
                <div className="w-3/12">
                  <Moment interval={0} format="DD-MM-YYYY hh:mm a">
                    {createdAt}
                  </Moment>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    );
  };

  return (
    <Scaffold left="New Orders" className="p-0 text-[15px]">
      <div className="py-3 text-ash font-medium flex flex-row items-center gap-2 px-5 text-[12px]">
        <div className="w-3/12">Order Number</div>
        <div className="w-3/12">Customer</div>
        <div className="w-3/12">Amount</div>
        <div className="w-3/12">Discount Amount</div>
        <div className="w-3/12">Delivery Method</div>
        <div className="w-3/12">Time</div>
      </div>
      <Separator />
      <div className="">{<TopItemsList />}</div>
    </Scaffold>
  );
};

export default NewOrders;
